import * as React from 'react';
import styled from '@emotion/styled';
import { MarkAsFavorite } from '../../../components/MarkAsFavorite';
import { ISearchResultProps } from '../SearchPage';
import { BreakpointsEnum } from '../../../helpers/breakpoints';

let style: any = {
    markAsFavorite: { position: 'absolute', right: '20px', marginTop: '2px' },
    imagePlaceHolder: { width: '100%', height: '180px', display: 'flex' },
};

const ImageStyled = styled.img`
    object-fit: cover;
    height: inherit;
    width: inherit;
    &.routeImage {
        @media (min-width: ${BreakpointsEnum.xss}) {
            object-fit: fill;
        }
        @media (min-width: ${BreakpointsEnum.xs}) {
            object-fit: cover;
        }
    }
`;
export class SearchResultItemTopSection extends React.Component<ISearchResultProps> {
    render() {
        const {
            cruise,
            hideFavoritesIcon,
            isFavorite,
            addToFavorites,
            removeFromFavorites,
            searchPageType,
        } = this.props;
        const { shipImage, routeImageLarge, routeMapImage } = cruise;
        let headerImage =
            searchPageType === 'map' || searchPageType === 'mapWithNoUGC'
                ? routeMapImage
                : searchPageType === 'ship'
                ? shipImage
                : routeImageLarge;
        const hasRouteImage = Boolean(routeMapImage);

        style.imagePlaceHolder =
            searchPageType === 'map' || searchPageType === 'mapWithNoUGC'
                ? { ...style.imagePlaceHolder, ...{ height: '225px' } }
                : style.imagePlaceHolder;

        return (
            <div style={style.imagePlaceHolder}>
                {!hideFavoritesIcon && (
                    <MarkAsFavorite
                        wrapperStyle={style.markAsFavorite}
                        cruiseNid={cruise.cruiseNid}
                        isFavorite={isFavorite}
                        addToFavorites={addToFavorites}
                        removeFromFavorites={removeFromFavorites}
                    />
                )}
                <ImageStyled
                    src={headerImage || shipImage}
                    alt={cruise.companyTitle}
                    className={hasRouteImage ? 'routeImage' : ''}
                />
            </div>
        );
    }
}
